import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';
import Index from './Index.vue';

import AgentReportsIndex from './AgentReportsIndex.vue';
import InboxReportsIndex from './InboxReportsIndex.vue';
import TeamReportsIndex from './TeamReportsIndex.vue';
import LabelReportsIndex from './LabelReportsIndex.vue';

import AgentReportsShow from './AgentReportsShow.vue';
import InboxReportsShow from './InboxReportsShow.vue';
import TeamReportsShow from './TeamReportsShow.vue';
import LabelReportsShow from './LabelReportsShow.vue';

import AgentReports from './AgentReports.vue';
import InboxReports from './InboxReports.vue';
import LabelReports from './LabelReports.vue';
import TeamReports from './TeamReports.vue';

import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import LiveReports from './LiveReports.vue';
import SupervisorDashboard from './SupervisorDashboard.vue';
import SLAReports from './SLAReports.vue';
import QualityReports from './QualityReports.vue';
import ClosingReports from './ClosingReports.vue';
import AgentLoginReports from './AgentLoginReports.vue';
import TransferReports from './TransferReports.vue';
import RescheduleReports from './RescheduleReports.vue';
import ContactReasonReports from './ContactReasonReports.vue';
import HourlyReports from './HourlyReports.vue';
import ReopenReports from './ReopenReports.vue';
import NoResponseReports from './NoResponseReports.vue';
import WhatsappTemplateReports from './WhatsappTemplateReports.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
};

const oldReportRoutes = [
  {
    path: 'agent',
    name: 'agent_reports',
    meta,
    component: AgentReports,
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    meta,
    component: InboxReports,
  },
  {
    path: 'label',
    name: 'label_reports',
    meta,
    component: LabelReports,
  },
  {
    path: 'teams',
    name: 'team_reports',
    meta,
    component: TeamReports,
  },
];

const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta,
    component: AgentReportsIndex,
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta,
    component: AgentReportsShow,
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta,
    component: InboxReportsIndex,
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta,
    component: InboxReportsShow,
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta,
    component: TeamReportsIndex,
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta,
    component: TeamReportsShow,
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta,
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta,
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'account_overview_reports', params: to.params };
          },
        },
        {
          path: 'supervisor',
          name: 'supervisor_dashboard_reports',
          meta,
          component: SupervisorDashboard,
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          component: LiveReports,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta,
          component: Index,
        },
        {
          path: 'quality',
          name: 'quality_reports',
          meta,
          component: QualityReports,
        },
        {
          path: 'closing',
          name: 'closing_reports',
          meta,
          component: ClosingReports,
        },
        {
          path: 'agent-logins',
          name: 'agent_login_reports',
          meta,
          component: AgentLoginReports,
        },
        {
          path: 'transfers',
          name: 'transfer_reports',
          meta,
          component: TransferReports,
        },
        {
          path: 'reschedules',
          name: 'reschedule_reports',
          meta,
          component: RescheduleReports,
        },
        {
          path: 'contact-reasons',
          name: 'contact_reason_reports',
          meta,
          component: ContactReasonReports,
        },
        {
          path: 'hourly',
          name: 'hourly_reports',
          meta,
          component: HourlyReports,
        },
        {
          path: 'reopens',
          name: 'reopen_reports',
          meta,
          component: ReopenReports,
        },
        {
          path: 'no-response',
          name: 'no_response_reports',
          meta,
          component: NoResponseReports,
        },
        {
          path: 'whatsapp-templates',
          name: 'whatsapp_template_reports',
          meta,
          component: WhatsappTemplateReports,
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'sla',
          name: 'sla_reports',
          meta,
          component: SLAReports,
        },
        {
          path: 'csat',
          name: 'csat_reports',
          meta,
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta,
          component: BotReports,
        },
      ],
    },
  ],
};
